var map = {
	"./Analytics": 722,
	"./Analytics.js": 722,
	"./Links.html": 1525,
	"./Robots.txt": 1526,
	"./TagManager": 723,
	"./TagManager.js": 723,
	"./Wayfinder": 724,
	"./Wayfinder.js": 724,
	"./favicon.ico": 1527,
	"./google59e421ebfe8a8015.html": 1528,
	"./im.html": 1529,
	"./images/2023-og-image-klo.jpg": 1530,
	"./images/Allissue.PNG": 1531,
	"./images/Arrow-Right.PNG": 1532,
	"./images/CYB2.jpg": 1533,
	"./images/Fullissue.PNG": 1534,
	"./images/Home-Help-mousehover.png": 1535,
	"./images/Home-Help.png": 1536,
	"./images/Home-search-mousehover.png": 1537,
	"./images/Home-search.png": 1538,
	"./images/List-Style.PNG": 1539,
	"./images/NextArticle.PNG": 1540,
	"./images/Outlook-WK.jpg": 1541,
	"./images/Plus.PNG": 1542,
	"./images/Rss-Default.png": 1543,
	"./images/Rss-Hover.png": 1544,
	"./images/WK.PNG": 1545,
	"./images/WkFooter.PNG": 1546,
	"./images/ajax-loader.gif": 1547,
	"./images/amex.png": 1548,
	"./images/arrow_down.png": 1549,
	"./images/arrow_up.png": 1550,
	"./images/authorSpotlight/adamLiberman.jpg": 1551,
	"./images/authorSpotlight/alanChristopherNeal.jpg": 1552,
	"./images/authorSpotlight/alastairSutton.jpg": 1553,
	"./images/authorSpotlight/albertJanVanDenBerg.jpg": 1554,
	"./images/authorSpotlight/alexanderRust.jpg": 1555,
	"./images/authorSpotlight/andreAlen.jpg": 1556,
	"./images/authorSpotlight/andreaBiondi.jpg": 1557,
	"./images/authorSpotlight/andreasRZiegler.jpg": 1558,
	"./images/authorSpotlight/author-Esme.png": 1559,
	"./images/authorSpotlight/author-roger.png": 1560,
	"./images/authorSpotlight/author-spot1.png": 1561,
	"./images/authorSpotlight/berntHugenholtz.jpg": 1562,
	"./images/authorSpotlight/bobWessels.jpg": 1563,
	"./images/authorSpotlight/edwinVermulst.jpg": 1564,
	"./images/authorSpotlight/ericSchwartz.jpg": 1565,
	"./images/authorSpotlight/frankEijsvogels.jpg": 1566,
	"./images/authorSpotlight/frankHendrickx.jpg": 1567,
	"./images/authorSpotlight/garyBorn.jpg": 1568,
	"./images/authorSpotlight/jeanFrancoisBelis.jpg": 1569,
	"./images/authorSpotlight/jeffreyLSnyder.jpg": 1570,
	"./images/authorSpotlight/jochenBuling.jpg": 1571,
	"./images/authorSpotlight/jochenBühling.jpg": 1572,
	"./images/authorSpotlight/jochenB├╝hling.jpg": 1573,
	"./images/authorSpotlight/johannMuller.jpg": 1574,
	"./images/authorSpotlight/johnBalfour.jpg": 1575,
	"./images/authorSpotlight/jonathanSLux.jpg": 1576,
	"./images/authorSpotlight/klausPeterBerger.jpg": 1577,
	"./images/authorSpotlight/lucieGuibault.jpg": 1578,
	"./images/authorSpotlight/manfredWeiss.jpg": 1579,
	"./images/authorSpotlight/michaelHeimert.jpg": 1580,
	"./images/authorSpotlight/nadjaAlexander.jpg": 1581,
	"./images/authorSpotlight/nunoPiresDeCarvalho.jpg": 1582,
	"./images/authorSpotlight/peterChrocziel.jpg": 1583,
	"./images/authorSpotlight/peterFCBegg.jpg": 1584,
	"./images/authorSpotlight/rikTorfs.jpg": 1585,
	"./images/authorSpotlight/ritaDeLaFeria.jpg": 1586,
	"./images/authorSpotlight/robVernout.jpg": 1587,
	"./images/authorSpotlight/russellELevine.jpg": 1588,
	"./images/authorSpotlight/silkeHeinz.jpg": 1589,
	"./images/authorSpotlight/silviaFazio.jpg": 1590,
	"./images/authorSpotlight/steefBartman.jpg": 1591,
	"./images/authorSpotlight/stefaanVanDenBogaert.jpg": 1592,
	"./images/authorSpotlight/stefanKroll.jpg": 1593,
	"./images/authorSpotlight/stefanSchmid.jpg": 1594,
	"./images/authorSpotlight/tugrulAnsay.jpg": 1595,
	"./images/authorSpotlight/verenaVonBomhard.jpg": 1596,
	"./images/authorSpotlight/vincentVerouden.jpg": 1597,
	"./images/authorSpotlight/willemHoyngs.jpg": 1598,
	"./images/authorSpotlight/yvesDerains.jpg": 1599,
	"./images/banner-image-lg.jpeg": 1600,
	"./images/captcha.png": 1601,
	"./images/card code.png": 1602,
	"./images/cart-down.svg": 1603,
	"./images/cart.png": 1604,
	"./images/check.png": 1605,
	"./images/csv.png": 1606,
	"./images/email-mouseover.png": 1607,
	"./images/email.png": 1608,
	"./images/etoc-mouseover.png": 1609,
	"./images/etoc.png": 1610,
	"./images/export-csv-Grey.svg": 1611,
	"./images/export-csv-dafault.svg": 1612,
	"./images/export-csv-default.svg": 1613,
	"./images/facebook.png": 1614,
	"./images/facebook_mouseover.png": 1615,
	"./images/green-arrow.png": 1616,
	"./images/green-tick.svg": 1617,
	"./images/linked_in.png": 1618,
	"./images/linkedin_mousover.png": 1619,
	"./images/login.png": 1620,
	"./images/mastercard.png": 1621,
	"./images/pdf-icon-no-text.svg": 1622,
	"./images/pdf-icon-with-text.svg": 1623,
	"./images/question_mark_mouseover.png": 1624,
	"./images/questionmark_default.png": 1625,
	"./images/rss-mouseover.png": 1626,
	"./images/rss.png": 1627,
	"./images/scopusLogoOrange.svg": 1628,
	"./images/search question - MouseHover.png": 1629,
	"./images/search question.png": 1630,
	"./images/search_button.png": 1631,
	"./images/search_button_Mousehover.png": 1632,
	"./images/search_mouseover.png": 1633,
	"./images/twitter-mouseover.png": 1634,
	"./images/twitter.png": 1635,
	"./images/visa.png": 1636,
	"./images/white-small.svg": 1637,
	"./index.html": 1638,
	"./manifest": 725,
	"./manifest.json": 725,
	"./maxsizeimages/Allissue.PNG": 1639,
	"./maxsizeimages/Arrow-Right.PNG": 1640,
	"./maxsizeimages/Fullissue.PNG": 1641,
	"./maxsizeimages/Home-Help-mousehover.png": 1642,
	"./maxsizeimages/Home-Help.png": 1643,
	"./maxsizeimages/Home-search-mousehover.png": 1644,
	"./maxsizeimages/Home-search.png": 1645,
	"./maxsizeimages/List-Style.PNG": 1646,
	"./maxsizeimages/NextArticle.PNG": 1647,
	"./maxsizeimages/Outlook-WK.jpg": 1648,
	"./maxsizeimages/Plus.PNG": 1649,
	"./maxsizeimages/Rss-Default.png": 1650,
	"./maxsizeimages/Rss-Hover.png": 1651,
	"./maxsizeimages/WK.PNG": 1652,
	"./maxsizeimages/WkFooter.PNG": 1653,
	"./maxsizeimages/ajax-loader.gif": 1654,
	"./maxsizeimages/amex.png": 1655,
	"./maxsizeimages/arrow_down.png": 1656,
	"./maxsizeimages/arrow_up.png": 1657,
	"./maxsizeimages/authorSpotlight/adamLiberman.jpg": 1658,
	"./maxsizeimages/authorSpotlight/alanChristopherNeal.jpg": 1659,
	"./maxsizeimages/authorSpotlight/alastairSutton.jpg": 1660,
	"./maxsizeimages/authorSpotlight/albertJanVanDenBerg.jpg": 1661,
	"./maxsizeimages/authorSpotlight/alexanderRust.jpg": 1662,
	"./maxsizeimages/authorSpotlight/andreAlen.jpg": 1663,
	"./maxsizeimages/authorSpotlight/andreaBiondi.jpg": 1664,
	"./maxsizeimages/authorSpotlight/andreasRZiegler.jpg": 1665,
	"./maxsizeimages/authorSpotlight/author-Esme.png": 1666,
	"./maxsizeimages/authorSpotlight/author-roger.png": 1667,
	"./maxsizeimages/authorSpotlight/author-spot1.png": 1668,
	"./maxsizeimages/authorSpotlight/berntHugenholtz.jpg": 1669,
	"./maxsizeimages/authorSpotlight/bobWessels.jpg": 1670,
	"./maxsizeimages/authorSpotlight/edwinVermulst.jpg": 1671,
	"./maxsizeimages/authorSpotlight/ericSchwartz.jpg": 1672,
	"./maxsizeimages/authorSpotlight/frankEijsvogels.jpg": 1673,
	"./maxsizeimages/authorSpotlight/frankHendrickx.jpg": 1674,
	"./maxsizeimages/authorSpotlight/garyBorn.jpg": 1675,
	"./maxsizeimages/authorSpotlight/jeanFrancoisBelis.jpg": 1676,
	"./maxsizeimages/authorSpotlight/jeffreyLSnyder.jpg": 1677,
	"./maxsizeimages/authorSpotlight/jochenBühling.jpg": 1678,
	"./maxsizeimages/authorSpotlight/johannMuller.jpg": 1679,
	"./maxsizeimages/authorSpotlight/johnBalfour.jpg": 1680,
	"./maxsizeimages/authorSpotlight/jonathanSLux.jpg": 1681,
	"./maxsizeimages/authorSpotlight/klausPeterBerger.jpg": 1682,
	"./maxsizeimages/authorSpotlight/lucieGuibault.jpg": 1683,
	"./maxsizeimages/authorSpotlight/manfredWeiss.jpg": 1684,
	"./maxsizeimages/authorSpotlight/michaelHeimert.jpg": 1685,
	"./maxsizeimages/authorSpotlight/nadjaAlexander.jpg": 1686,
	"./maxsizeimages/authorSpotlight/nunoPiresDeCarvalho.jpg": 1687,
	"./maxsizeimages/authorSpotlight/peterChrocziel.jpg": 1688,
	"./maxsizeimages/authorSpotlight/peterFCBegg.jpg": 1689,
	"./maxsizeimages/authorSpotlight/rikTorfs.jpg": 1690,
	"./maxsizeimages/authorSpotlight/ritaDeLaFeria.jpg": 1691,
	"./maxsizeimages/authorSpotlight/robVernout.jpg": 1692,
	"./maxsizeimages/authorSpotlight/russellELevine.jpg": 1693,
	"./maxsizeimages/authorSpotlight/silkeHeinz.jpg": 1694,
	"./maxsizeimages/authorSpotlight/silviaFazio.jpg": 1695,
	"./maxsizeimages/authorSpotlight/steefBartman.jpg": 1696,
	"./maxsizeimages/authorSpotlight/stefaanVanDenBogaert.jpg": 1697,
	"./maxsizeimages/authorSpotlight/stefanKroll.jpg": 1698,
	"./maxsizeimages/authorSpotlight/stefanSchmid.jpg": 1699,
	"./maxsizeimages/authorSpotlight/tugrulAnsay.jpg": 1700,
	"./maxsizeimages/authorSpotlight/verenaVonBomhard.jpg": 1701,
	"./maxsizeimages/authorSpotlight/vincentVerouden.jpg": 1702,
	"./maxsizeimages/authorSpotlight/willemHoyngs.jpg": 1703,
	"./maxsizeimages/authorSpotlight/yvesDerains.jpg": 1704,
	"./maxsizeimages/banner-image-lg.jpeg": 1705,
	"./maxsizeimages/books/ADR.JPG": 1706,
	"./maxsizeimages/books/AIAJ.jpg": 1707,
	"./maxsizeimages/books/AILA.jpg": 1708,
	"./maxsizeimages/books/AMDM.JPG": 1709,
	"./maxsizeimages/books/ASAB.jpg": 1710,
	"./maxsizeimages/books/BARBIT.JPG": 1711,
	"./maxsizeimages/books/BCDR.jpg": 1712,
	"./maxsizeimages/books/BRA.JPG": 1713,
	"./maxsizeimages/books/BULA.jpg": 1714,
	"./maxsizeimages/books/Banking.png": 1715,
	"./maxsizeimages/books/CAM.jpg": 1716,
	"./maxsizeimages/books/CIVI.jpg": 1717,
	"./maxsizeimages/books/CIVI.png": 1718,
	"./maxsizeimages/books/CMP.jpg": 1719,
	"./maxsizeimages/books/COLA.JPG": 1720,
	"./maxsizeimages/books/COMM.jpg": 1721,
	"./maxsizeimages/books/CONS.jpg": 1722,
	"./maxsizeimages/books/CONT.jpg": 1723,
	"./maxsizeimages/books/CORP.jpg": 1724,
	"./maxsizeimages/books/CRIM.jpg": 1725,
	"./maxsizeimages/books/CYB.jpg": 1726,
	"./maxsizeimages/books/CivilPro.png": 1727,
	"./maxsizeimages/books/Commercial.png": 1728,
	"./maxsizeimages/books/Competition.png": 1729,
	"./maxsizeimages/books/EAL.jpg": 1730,
	"./maxsizeimages/books/ECTA.jpg": 1731,
	"./maxsizeimages/books/ECTAX.jpg": 1732,
	"./maxsizeimages/books/EEELR.jpg": 1733,
	"./maxsizeimages/books/EELR.jpg": 1734,
	"./maxsizeimages/books/EERR.jpg": 1735,
	"./maxsizeimages/books/EFJ.jpg": 1736,
	"./maxsizeimages/books/EICLIT.jpg": 1737,
	"./maxsizeimages/books/ENER.jpg": 1738,
	"./maxsizeimages/books/ENVI.jpg": 1739,
	"./maxsizeimages/books/ERPL.jpg": 1740,
	"./maxsizeimages/books/EUCL.jpg": 1741,
	"./maxsizeimages/books/EUCM.jpg": 1742,
	"./maxsizeimages/books/EULR.jpg": 1743,
	"./maxsizeimages/books/EURO.jpg": 1744,
	"./maxsizeimages/books/Energy-Competition.png": 1745,
	"./maxsizeimages/books/Energy.png": 1746,
	"./maxsizeimages/books/EuCML.jpg": 1747,
	"./maxsizeimages/books/European-Union.png": 1748,
	"./maxsizeimages/books/FAMI.jpg": 1749,
	"./maxsizeimages/books/GPLR.JPG": 1750,
	"./maxsizeimages/books/GTCJ.jpg": 1751,
	"./maxsizeimages/books/IBT.jpg": 1752,
	"./maxsizeimages/books/IEADA.jpg": 1753,
	"./maxsizeimages/books/IELL.jpg": 1754,
	"./maxsizeimages/books/IGO.jpg": 1755,
	"./maxsizeimages/books/IJCL.jpg": 1756,
	"./maxsizeimages/books/ILEL.jpg": 1757,
	"./maxsizeimages/books/INSU.jpg": 1758,
	"./maxsizeimages/books/IPRO.jpg": 1759,
	"./maxsizeimages/books/JOIA.jpg": 1760,
	"./maxsizeimages/books/JournalOfWorldTrade.png": 1761,
	"./maxsizeimages/books/LEIE.jpg": 1762,
	"./maxsizeimages/books/LL_9789065449054.jpg": 1763,
	"./maxsizeimages/books/Latest-update1.png": 1764,
	"./maxsizeimages/books/Law.PNG": 1765,
	"./maxsizeimages/books/MCO.jpg": 1766,
	"./maxsizeimages/books/MEDA.jpg": 1767,
	"./maxsizeimages/books/MEDI.jpg": 1768,
	"./maxsizeimages/books/MIGR.jpg": 1769,
	"./maxsizeimages/books/MLH.PNG": 1770,
	"./maxsizeimages/books/MLH.jpg": 1771,
	"./maxsizeimages/books/MaritimeLaw.PNG": 1772,
	"./maxsizeimages/books/PRIL.jpg": 1773,
	"./maxsizeimages/books/PROP.jpg": 1774,
	"./maxsizeimages/books/RBA.jpg": 1775,
	"./maxsizeimages/books/RELI.jpg": 1776,
	"./maxsizeimages/books/RLVR.JPG": 1777,
	"./maxsizeimages/books/SOCS.jpg": 1778,
	"./maxsizeimages/books/SPORT.jpg": 1779,
	"./maxsizeimages/books/TAXI.jpg": 1780,
	"./maxsizeimages/books/TORT.jpg": 1781,
	"./maxsizeimages/books/TRAD.jpg": 1782,
	"./maxsizeimages/books/TRAN.jpg": 1783,
	"./maxsizeimages/books/Transport-law.png": 1784,
	"./maxsizeimages/books/WOCO.jpg": 1785,
	"./maxsizeimages/books/WTAM.jpg": 1786,
	"./maxsizeimages/books/author-Esme.png": 1787,
	"./maxsizeimages/books/author-roger.png": 1788,
	"./maxsizeimages/books/author-spot1.png": 1789,
	"./maxsizeimages/books/blank.png": 1790,
	"./maxsizeimages/books/common-market-law.png": 1791,
	"./maxsizeimages/books/corporate.PNG": 1792,
	"./maxsizeimages/books/corporatecomm.PNG": 1793,
	"./maxsizeimages/books/encyclopedia.PNG": 1794,
	"./maxsizeimages/books/transport.png": 1795,
	"./maxsizeimages/card code.png": 1796,
	"./maxsizeimages/cart.png": 1797,
	"./maxsizeimages/check.png": 1798,
	"./maxsizeimages/csv.png": 1799,
	"./maxsizeimages/email-mouseover.png": 1800,
	"./maxsizeimages/email.png": 1801,
	"./maxsizeimages/etoc-mouseover.png": 1802,
	"./maxsizeimages/etoc.png": 1803,
	"./maxsizeimages/facebook.png": 1804,
	"./maxsizeimages/facebook_mouseover.png": 1805,
	"./maxsizeimages/green-arrow.png": 1806,
	"./maxsizeimages/linked_in.png": 1807,
	"./maxsizeimages/linkedin_mousover.png": 1808,
	"./maxsizeimages/login.png": 1809,
	"./maxsizeimages/mastercard.png": 1810,
	"./maxsizeimages/pdf-icon-no-text.svg": 1811,
	"./maxsizeimages/pdf-icon-with-text.svg": 1812,
	"./maxsizeimages/question_mark_mouseover.png": 1813,
	"./maxsizeimages/questionmark_default.png": 1814,
	"./maxsizeimages/rss-mouseover.png": 1815,
	"./maxsizeimages/rss.png": 1816,
	"./maxsizeimages/search question - MouseHover.png": 1817,
	"./maxsizeimages/search question.png": 1818,
	"./maxsizeimages/search_button.png": 1819,
	"./maxsizeimages/search_button_Mousehover.png": 1820,
	"./maxsizeimages/search_mouseover.png": 1821,
	"./maxsizeimages/twitter-mouseover.png": 1822,
	"./maxsizeimages/twitter.png": 1823,
	"./maxsizeimages/visa.png": 1824,
	"./siqpagetag": 726,
	"./siqpagetag.js": 726,
	"./subscriber_journals.xml": 1825,
	"./subscribers.xml": 1826
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 423;


//////////////////
// WEBPACK FOOTER
// ./public ^\.\/.*$
// module id = 423
// module chunks = 1